import NotesWidgetModel from './notes-widget-model'
import _ from 'lodash'
import {sectionEndpoint} from 'scoreboard/components/bootslide/object-selector-menu'
import createWob from '../create-wob'
import option from 'scoreboard/components/bootslide/menu-icon-option'
import AddDomainObjectEndpoint from 'scoreboard/components/bootslide/add-domain-object-endpoint'
import i18n from 'scoreboard/components/i18n'

var AddNotesWidgetOption = AddDomainObjectEndpoint.extend({
	add: function (node) {
		var widget = new NotesWidgetModel(
			{
				properties: _.extend({
					type: 'notes',
					section: this.section,
					domainObjectId: node.id,
					displayMode: 'tiles',
					showLabel: true,
					showControls: true,
					showModifyDate: true,
					showReplies: true,
					// #21033 next 3 "show" properties don't actually do anything in
					// 'tiles' displayMode, but we want them on by default in case
					// the user switches to 'full' displayMode
					showAuthor: true,
					showNoteAbout: true,
					showNoteAppliesTo: true,
					fontSize: '13' // #21352
				}, sectionDefaults[this.section])
			})

		createWob(this.canvas, widget, { fetchData: true }, this.bootslideMenu)
	}
})

var sectionDefaults = {
	scorecards: {
		showNoteDescendants: true
	},
	initiatives: {}
}

function scorecards (bootslideMenu) {
	const label = 'dashboards.dropdown.scorecardNodeNotes'
	return {
		label: i18n.get(label),
		content: option('add-widget-note', label),
		contentEndpoint: sectionEndpoint(bootslideMenu, 'scorecards', AddNotesWidgetOption)
	}
}

function initiatives (bootslideMenu) {
	const label = 'dashboards.dropdown.initiativeNotes'
	return {
		label: i18n.get(label),
		content: option('add-widget-note', label),
		contentEndpoint: sectionEndpoint(bootslideMenu, 'initiatives', AddNotesWidgetOption)
	}
}

export { scorecards, initiatives }